<script lang="typescript">
import {functions} from "../services/firebase"
import router from "page";
import { afterUpdate, beforeUpdate, onMount } from "svelte";
import type { Offer } from "../models/Offer";
import { filter } from "lodash";
import { DuplicationModel } from "../models/DuplicationModel";
import { fade } from "svelte/transition";
export let offerOwnerList = [];
export let fromOwnerFolder = false
let display = "none";
let loading = false;
let error = ""
let offerName="";
let offerOwner="";
let duplicate = false;
let retrievingOfferNames = false;
let offerLists: Record<string, Offer[]> = {};
let currentOfferList = [];
let currentDuplicateOwner;
let currentDuplicateOffer;
let duplicateResearch = true;

let duplicateObject = new DuplicationModel()

export function show() {
  const body = document.querySelector('body')
  const modal = document.querySelector('.modal')
  modal.classList.toggle('opacity-0')
  modal.classList.toggle('pointer-events-none')
  body.classList.toggle('modal-active')
}

beforeUpdate(()=>{
  if (fromOwnerFolder && offerOwnerList && offerOwnerList[0]){
    offerOwner = offerOwnerList[0].name;
    console.log(offerOwner)
  }
})

function researchCheck(evt: Event & { currentTarget: EventTarget & HTMLInputElement; }){
  const isChecked = evt.currentTarget.checked;
  duplicateObject.research.demographicInsights = isChecked;
  duplicateObject.research.existingSolutions = isChecked;
  duplicateObject.research.curiosityCorruption = isChecked;
  duplicateObject.research.extraNotes = isChecked;

}

async function selectDuplicateOfferOwner(evt: FocusEvent & { currentTarget: EventTarget & HTMLSelectElement }){
  retrievingOfferNames = true;
  currentDuplicateOffer = null;
  console.log("current val ",evt.currentTarget.value)
  const selectedVal = evt.currentTarget.value;
  if(!selectedVal){
    currentOfferList = [];
    retrievingOfferNames = false;
    return;
  }
  if(offerLists[selectedVal] != null){
    currentOfferList = offerLists[selectedVal];
    retrievingOfferNames = false;
    return;
  }
  try {
      retrievingOfferNames = true;
      const offerListFunc = functions.httpsCallable("retrieveOffers");
      let offerList;
  
      offerList = await offerListFunc({offerOwner: selectedVal})
      
      console.log(offerList.data)
      offerLists[selectedVal] = offerList.data
    }catch(error){
        console.log("Error retrieving user documents ", error);
    } finally{
      retrievingOfferNames = false;
    }
}

async function createOffer(){
    error = ""
    loading = true;
    let offer = {
            name: offerName,
            offerOwner,
            duplicate: false,
            duplicateModel: null
    }
    if(duplicate && currentDuplicateOwner != null && currentDuplicateOffer != null){
      duplicateObject.offerOwnerKey = currentDuplicateOwner;
      duplicateObject.offerID = currentDuplicateOffer;
      offer.duplicate = true;
      offer.duplicateModel =  duplicateObject;
    }
    console.log(offer)
    try{
        const newOfferCallable = functions.httpsCallable("newOffer");
        const offerCreationResult = await newOfferCallable(offer)
        const offerID = offerCreationResult.data.offerID
        router.redirect(`/offers/${offerID}`)
    }catch(error){
        console.log("Error creating new offer ", error);
        error = error
    } finally{
        loading = false;
    }
}
</script>
<div class="modal opacity-0 pointer-events-none fixed w-full h-full top-0 left-0 flex items-center justify-center">
  <div class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"></div>
  
  <div class="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">
    
    <div class="modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50">
      <svg class="fill-current text-white" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
        <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
      </svg>
      <span class="text-sm">(Esc)</span>
    </div>

    <!-- Add margin if you want to see some of the overlay behind the modal-->
    <div class="modal-content text-left ">
      <!--Title-->
      <div class="flex justify-between items-center pt-4 px-6 pb-3 bg-primary fill-current">
        <p class="text-2xl font-bold">Start a New Offer</p>
        <div on:click={show} class="modal-close bg-danger cursor-pointer p-4 z-50 rounded">
          <svg class="fill-current  text-white" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
          </svg>
        </div>
      </div>

      <!--Body-->
      <form id="newOfferForm" class="w3-container px-6 grid">

        <label for="offerName">Offer Name: </label>
        <input name="offerName" 
        autocomplete="off" 
        class="border-black border-2 rounded" 
        bind:value={offerName}
        type="text">
        <label for="offerOwner">Offer Owner Name: </label>
        <input name="offerOwner" 
        class="border-black border-2 rounded"
        disabled={fromOwnerFolder}
        list="OfferOwners"
        autocomplete="off" 
        bind:value={offerOwner}
        type="text">
        <datalist id="OfferOwners">
            {#each offerOwnerList as offerOwner}
                <option value={offerOwner.name}></option>
            {/each}
            
        </datalist>

        <label for="duplicate" class="mt2">
          <input 
          name="duplicate" 
          autocomplete="off" 
          class="w-6 mt-2 h-6 pl-6 ring-2 ring-offset-blue-400" 
          bind:checked={duplicate}
          type="checkbox"> Duplicate the Research, Mechanism, and / or Brief from an existing offer.
        </label>
  
        {#if duplicate}
          <label for="duplicateFromOwner">Select the owner name of the offer to duplicate: </label>
          <!-- svelte-ignore a11y-no-onchange -->
          <select
          bind:value={currentDuplicateOwner} 
          on:change={selectDuplicateOfferOwner}
          name="duplicateFromOwner" 
          class="border-black border-2 mt-2 rounded">
            <option value={null} selected>Select the owner the original offer belongs to.</option>
            {#each offerOwnerList as offerOwner}
              <option value={offerOwner.key}>{offerOwner.name}</option>
            {/each}
          </select>
          {#if offerLists[currentDuplicateOwner] == null && retrievingOfferNames}
            <!-- svelte-ignore a11y-no-onchange -->
            <div class="w-full text-center justify-center i pt-6">
              <i class="fas fa-spinner fa-spin fa-2x"></i> 
            </div>
          {:else if currentDuplicateOwner != null &&  offerLists[currentDuplicateOwner] != null }
            <!-- svelte-ignore a11y-no-onchange -->
            <label for="duplicateFromOffer">
              Pick a source offer to duplicate:
              <select
              transition:fade|local
              bind:value={currentDuplicateOffer} 
              name="duplicateFromOffer" 
              class="border-black border-2 mt-2 rounded">
                <option value={null} selected>Select an offer owner to duplicate from.</option>
                {#each offerLists[currentDuplicateOwner] as offer}
                  <option value={offer.id}>{offer.name}</option>
                {/each}
              </select>
            </label>
            {#if currentDuplicateOffer != null}
            <label>
              <input type="checkbox" 
              on:change={researchCheck}
              bind:checked={duplicateResearch}>
                Research
            </label>
            <ol class="pl-4">
              <li>
              <label>
                <input type="checkbox" bind:checked={duplicateObject.research.demographicInsights}>
                  Demographic Insights
              </label>
              </li>
              <li>
              <label>
                <input type="checkbox" bind:checked={duplicateObject.research.existingSolutions}>
                  Other Existing Solutions
              </label>
              </li>
              <li>
              <label>
                <input type="checkbox" bind:checked={duplicateObject.research.curiosityCorruption}>
                  Curiosity & Corrupton
              </label>
              </li>
              <li>
              <label>
                <input type="checkbox" bind:checked={duplicateObject.research.extraNotes}>
                  Extra Notes
              </label>
              </li>
            </ol>
            <label>
              <input type="checkbox" 
                bind:checked={duplicateObject.mechanism}>
                Mechanism
            </label>
            <label>
              <input type="checkbox" 
                bind:checked={duplicateObject.brief}>
                Brief
            </label>
            {/if}
          {/if}

        {/if}
    </form>

      <!--Footer-->
      <div class="flex justify-end p-2">
        <button 
        on:click={createOffer} 
        class="w3-button w3-round w3-black
        modal-close px-4 bg-blue-500 p-3 rounded-lg text-white hover:bg-indigo-400 disabled:opacity-50
        {loading || offerName.length == 0 || offerOwner.length == 0 ? 'pointer-events-none' : ''}"
        disabled={loading || offerName.length == 0 || offerOwner.length == 0 || (duplicate && (currentDuplicateOwner == null || currentDuplicateOffer == null))}>Create Offer</button>
        {error}
      </div>
      {#if offerName.length == 0 || offerOwner.length == 0}<p class="pl-1">Both fields must be filled out.</p>{/if}
    </div>
  </div>
</div>

<style>
.createOfferCard{
  max-width: 600px;
}

#newOfferModal span{
  background-color: red;
}
.w3-yellow {
    background-color: peachpuff !important;
}

footer {
  padding: 10px;
}

.modal {
transition: opacity 0.25s ease;
}
.modal-active {
  overflow-x: hidden;
  overflow-y: visible !important;
}
</style>